import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHome && !scrolled
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-md border-b border-background-200'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading text-lg">
              韩
            </span>
            <span className={`font-heading text-xl whitespace-nowrap transition-colors ${
              isHome && !scrolled ? 'text-background-50' : 'text-foreground-900'
            }`}>
              韩漫网
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700'
                    : isHome && !scrolled
                      ? 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                      : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700'
                  : isHome && !scrolled
                    ? 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                    : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </nav>

          <div className="flex items-center gap-3">
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
                isHome && !scrolled
                  ? 'text-background-50 hover:bg-background-50/10'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
              aria-label="菜单"
            >
              <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={`${cat.icon} text-base`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-information-line text-base"></i>
              </span>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}